import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { MAX_BOX_SLOTS, readSlotCount } from '../../utils/storageTree';

/**
 * Edit a box that is already on the map: name, and whether it is a slotted box.
 * Checking slotted asks for the slot count. Save stays disabled until that
 * count is filled.
 *
 * @param {Object} props
 * @param {import('../../utils/storageTree').StorageNode} props.box
 * @param {Function} props.onSave - ({ name, slotted, slotCount }) => boolean|void|Promise. Return false to keep the form open.
 * @param {Function} props.onCancel
 */
const StorageBoxEditForm = ({ box, onSave, onCancel }) => {
  const existingSlots = readSlotCount(box);
  const [name, setName] = useState(box?.name || '');
  const [slotted, setSlotted] = useState(existingSlots != null);
  const [slotCount, setSlotCount] = useState(existingSlots ? String(existingSlots) : '');
  const idPrefix = `box-edit-${box?.id ?? 'new'}`;
  const slotsMissing = slotted && !String(slotCount).trim();

  const handleSubmit = async event => {
    event.preventDefault();
    const ok = await onSave?.({
      name,
      slotted,
      slotCount: slotted ? slotCount : undefined,
    });
    if (ok === false) return;
  };

  return (
    <Form
      className="storage-node-add nodrag nopan nowheel"
      onSubmit={handleSubmit}
      onMouseDown={event => event.stopPropagation()}
      onClick={event => event.stopPropagation()}
    >
      <Form.Group>
        <Form.Label htmlFor={`${idPrefix}-name`} className="small mb-1">
          Box name
        </Form.Label>
        <Form.Control
          id={`${idPrefix}-name`}
          size="sm"
          value={name}
          onChange={event => setName(event.target.value)}
        />
      </Form.Group>
      <Form.Check
        id={`${idPrefix}-slotted`}
        className="small"
        type="checkbox"
        label="Slotted box"
        checked={slotted}
        onChange={event => {
          setSlotted(event.target.checked);
          if (!event.target.checked) setSlotCount('');
        }}
      />
      {slotted ? (
        <Form.Group>
          <Form.Label htmlFor={`${idPrefix}-slots`} className="small mb-1">
            Slots
          </Form.Label>
          <Form.Control
            id={`${idPrefix}-slots`}
            type="number"
            inputMode="numeric"
            min={1}
            max={MAX_BOX_SLOTS}
            step={1}
            size="sm"
            value={slotCount}
            onChange={event => setSlotCount(event.target.value)}
            placeholder="e.g. 81"
            required
          />
        </Form.Group>
      ) : null}
      <Button
        type="submit"
        size="sm"
        className="glass-primary-btn w-100"
        disabled={!name.trim() || slotsMissing}
      >
        Save
      </Button>
      <Button
        type="button"
        variant="link"
        size="sm"
        className="storage-node__cancel nodrag nopan p-0"
        onMouseDown={event => event.stopPropagation()}
        onClick={event => {
          event.stopPropagation();
          onCancel?.();
        }}
      >
        Cancel
      </Button>
    </Form>
  );
};

export default StorageBoxEditForm;
